<template>
	<div class="main" :class="{ iframe }">
		<loading :active="isLoading" background-color="transparent" is-full-page>
			<i class="fas fa-spinner fa-pulse" style="color: #007bff; font-size: 100px"></i>
		</loading>
		<b-container class="content" v-if="ready">
			<div class="white-background">
				<b-row class="votaciones-stats mx-md-auto">
					<b-col class="mb-3 mb-md-0" cols="12" md="6">
						<div class="votaciones-stats-percentage-container">
							<span>Porcentaje mesas escrutadas</span>
							<span class="votaciones-stats-percentage">{{ data.oldEleccion ? data.oldEleccion.porcentaje : 0 }}%</span>
						</div>
						<div class="votaciones-stats-national-text">Nivel nacional</div>
						<b-progress :value="data.oldEleccion ? data.oldEleccion.porcentaje : 0" max="100"></b-progress>
					</b-col>
					<b-col class="votaciones-stats-info" cols="12" md="6">
						<p class="votaciones-stats-last-update">
							Última actualización: <strong class="votaciones-stats-last-update-date">{{ updateDate }}</strong>
						</p>
						<p class="votaciones-stats-info-text">Resultados parciales. Fuente: SERVEL</p>
					</b-col>
				</b-row>
			</div>
			<div class="white-background" v-if="votaciones">
				<b-row class="votaciones mx-md-auto">
					<b-col v-for="(votacion, codPacto, index) in votaciones.pactos" cols="12" :key="votacion.pacto.cod_pacto">
						<div class="votacion" :class="index % 2 === 1 ? 'votacion-red' : ''">
							<h2 class="votacion-title">{{ votacion.pacto.glosa_pacto | capitalize }}</h2>
							<b-row>
								<b-col cols="6" v-for="(candidato, index) in votacion.candidatos" :key="candidato.cod_cand">
									<div
										class="candidato"
										:class="[
											index % 2 === 0 ? 'candidato-left' : 'candidato-right',
											{ 'candidato-ganador': electos[candidato.cod_cand] }
										]"
									>
										<div class="candidato-top">
											<img class="candidato-img" :src="`${imgPath}${candidato.cod_cand}.png`" />
											<div class="candidato-text">
												<div v-if="index % 2 === 0" class="candidato-name">
													{{ candidato.glosa_cand | capitalize }}{{ '\xa0' }}<i class="fas fa-check"></i>
												</div>
												<div v-else class="candidato-name">
													<i class="fas fa-check"></i>{{ '\xa0' }}{{ candidato.glosa_cand | capitalize }}
												</div>
												<div class="candidato-partido">
													{{ candidato.glosa_part | capitalize }}
												</div>
												<div class="candidato-stats">
													<div class="candidato-percentage">
														{{ votacion.total ? percentage(candidato.votos, votacion.total) : 0 | formatNumber }}%
													</div>
													<div class="candidato-votos">
														<strong>{{ candidato.votos | formatNumber }}</strong> votos
													</div>
												</div>
												<div class="ganador-badge">
													{{ candidato.cod_genero === 'F' ? 'GANADORA' : 'GANADOR' }}
												</div>
											</div>
										</div>
										<b-progress
											:class="{ 'no-progress': !votacion.total }"
											:value="votacion.total ? percentage(candidato.votos, votacion.total) : 0"
											max="100"
										></b-progress>
										<div class="candidato-bottom">
											<div v-if="index % 2 === 0" class="candidato-name">
												{{ candidato.glosa_cand | capitalize }}{{ '\xa0' }}<i class="fas fa-check"></i>
											</div>
											<div v-else class="candidato-name">
												<i class="fas fa-check"></i>{{ '\xa0' }}{{ candidato.glosa_cand | capitalize }}
											</div>
											<div class="candidato-partido">
												{{ candidato.glosa_part | capitalize }}
											</div>
										</div>
									</div>
								</b-col>
							</b-row>
						</div>
					</b-col>
					<b-col cols="12">
						<b-row class="votacion-stats mx-n1 mx-md-auto">
							<b-col class="votacion-stat px-1" cols="3">
								<p class="votacion-stat-name">Votos válidos:</p>
								<p class="votacion-stat-value">
									{{ votaciones.validos | formatNumber }}
								</p>
							</b-col>
							<b-col class="votacion-stat px-1" cols="3">
								<p class="votacion-stat-name">Blancos:</p>
								<p class="votacion-stat-value">
									{{ votaciones.blancos | formatNumber }}
								</p>
							</b-col>
							<b-col class="votacion-stat px-1" cols="3">
								<p class="votacion-stat-name">Nulos:</p>
								<p class="votacion-stat-value">
									{{ votaciones.nulos | formatNumber }}
								</p>
							</b-col>
							<b-col class="votacion-stat px-1" cols="3">
								<p class="votacion-stat-name">Total votos:</p>
								<p class="votacion-stat-value">
									{{ votaciones.total | formatNumber }}
								</p>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</div>
		</b-container>
	</div>
</template>

<script>
import { loadScheme, fetchVotacion, fetchActualizados, fetchElectos } from '../data/data-primarias.js'
import { getCandidatos, getVotosPrimarias } from '../data/queries'
import alasql from 'alasql'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
	components: {
		Loading
	},
	props: {
		iframe: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			electos: {},
			data: null,
			ready: false,
			votaciones: null,
			loading: false,
			imgPath: `${process.env.VUE_APP_DATA_URL}img/`
		}
	},

	computed: {
		isLoading() {
			return !this.ready || this.loading
		},
		updateDate() {
			if (!this?.data?.oldEleccion) {
				return 'Datos aún no disponibles'
			}

			const date = new Date(+this.data.oldEleccion.timestamp * 1000)

			return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} a las ${this.twoDigits(
				date.getHours()
			)}:${this.twoDigits(date.getMinutes())}`
		}
	},
	created() {
		window.alasql = alasql
		window.getVotosPrimarias = getVotosPrimarias
		window.getCandidatos = getCandidatos
		this.loading = true

		Promise.all([fetchActualizados(), fetchElectos(), loadScheme()]).then(([elecciones, electos]) => {
			this.data = {
				newEleccion: elecciones[4],
				oldEleccion: elecciones[4]
			}
			this.electos = electos
			this.loading = false
			this.ready = true

			this.interval = setInterval(() => {
				fetchActualizados().then(elecciones => {
					this.data.newEleccion = elecciones[4]
					this.getVotacion(true)
				})

				fetchElectos().then(electos => (this.electos = electos))
			}, 60000)

			this.getVotacion()
		})
	},
	destroyed() {
		clearInterval(this.interval)
	},
	methods: {
		getVotacion(automatic) {
			this.$nextTick(() => {
				const newEleccion = this.data.newEleccion
				const oldEleccion = this.data.oldEleccion

				/* En caso de que exista datos de la votación y la vieja votación no exista (Esto pasa cuando los datos de
				   la votación no existían en la ejecución anterior) o no se haya descargado aún o los datos son más recientes*/
				if (newEleccion && (!oldEleccion?.fetched || +oldEleccion.timestamp < +newEleccion.timestamp)) {
					this.loading = true
					this.votacion = null
					fetchVotacion(newEleccion.path, 4)
						.then(() => {
							this.data.oldEleccion = newEleccion
							this.data.oldEleccion.fetched = true
							this.setVotacion(this.data.oldEleccion)
							this.$nextTick(() => (this.loading = false))
						})
						.catch(err => {
							console.error(err)
							this.setVotacion(this.data.oldEleccion)
							this.$nextTick(() => (this.loading = false))
						})
				} else if (!automatic) {
					/* Cuando no existen datos de votación (Ej: el servel no ha enviado los datos aún) o los datos de la votación
					    anterior han sido descargados y aún no se han actualizado. Se verifica si existen datos ya descargados de la
						votación, si no existen de todas formas se pasa un objeto para que muestren los datos de los candidatos,
						con todos sus votos en 0 */
					this.votacion = null
					this.setVotacion(
						oldEleccion || {
							id: 4,
							path: null,
							timestamp: 0,
							porcentaje: 0,
							fdate: 0
						}
					)
				}
			})
		},
		setVotacion() {
			const votos = getVotosPrimarias()
			const votaciones = {
				pactos: {},
				nulos: 0,
				blancos: 0,
				validos: 0,
				total: 0
			}

			votos.forEach(votos => {
				if (votos.cod_cand !== 1) {
					if (!votaciones.pactos[votos.cod_pacto]) {
						votaciones.pactos[votos.cod_pacto] = {
							pacto: {
								cod_pacto: votos.cod_pacto,
								glosa_pacto: votos.glosa_pacto
							},
							candidatos: [],
							total: 0
						}
					}

					votaciones.pactos[votos.cod_pacto].candidatos.push(votos)
					votaciones.pactos[votos.cod_pacto].total += votos.votos
				} else {
					switch (votos.glosa_cand) {
						case 'Nulos':
							votaciones.nulos = votos.votos
							break
						case 'Blancos':
							votaciones.blancos = votos.votos
							break
						case 'Votos válidos':
							votaciones.validos = votos.votos
							break
					}
				}

				votaciones.total = votaciones.nulos + votaciones.blancos + votaciones.validos
			})

			Object.values(votaciones.pactos).forEach(pacto => {
				pacto.candidatos.sort((a, b) => a.can_orden - b.can_orden)
			})

			this.votaciones = votaciones

			if (window.parent) {
				window.parent.postMessage('show-data', '*')
			}
		},
		percentage(votos, total) {
			return (votos * 100) / total
		},
		twoDigits(n) {
			return Math.floor(n / 10) === 0 ? '0' + n : String(n)
		}
	}
}
</script>

<style scoped lang="scss">
.white-background {
	background-color: #fff;
}

.iframe .content {
	.votaciones {
		overflow: auto;
		position: relative;
		padding-bottom: 30px;
	}
}

.votaciones-stats {
	background-color: #fff;
	margin-bottom: 10px;
	padding: 20px 0;

	.votaciones-stats-percentage-container {
		color: #172a4c;
		display: flex;
		justify-content: space-between;
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 8px;
		line-height: 19px;

		.votaciones-stats-percentage {
			background-color: #fa2f35;
			border-radius: 5px;
			color: #fff;
			font-size: 20px;
			font-weight: bold;
			line-height: 25px;
			padding: 4px 12px;
		}
	}

	.votaciones-stats-national-text {
		color: #5c6981;
		font-size: 13px;
		line-height: 14px;
		margin-top: -12px;
		margin-bottom: 12px;
	}

	.progress {
		background-color: rgba(#8899a6, 0.3);

		::v-deep .progress-bar {
			background-color: #fa2f35;
		}
	}

	.votaciones-stats-last-update,
	.votaciones-stats-info-text {
		color: #5c6981;
		font-size: 13px;
		line-height: 14px;
		text-align: center;
	}

	.votaciones-stats-last-update {
		margin-bottom: 10px;
	}

	.votaciones-stats-last-update-date {
		color: #172a4c;
	}

	.votaciones-stats-info-text {
		font-size: 12px;
		line-height: 15px;
		margin-bottom: 0;
	}
}

.votaciones {
	background-color: #fff;
	padding-bottom: 100px;
	padding-top: 20px;
}

.votacion {
	margin-bottom: 45px;

	.votacion-title {
		color: #172a4c;
		font-size: 17px;
		font-weight: bold;
		line-height: 21px;
		margin-bottom: 16px;
		padding: 0 80px;
		text-align: center;
		position: relative;

		&::after {
			background-color: #368cf6;
			bottom: -16px;
			content: '';
			display: block;
			height: 2px;
			left: 50%;
			position: absolute;
			transform: translateX(-50%);
			width: 50px;
		}
	}

	&.votacion-red {
		.candidato {
			.candidato-percentage {
				color: #e55c5c;
			}

			.progress::v-deep .progress-bar {
				background-color: #e55c5c;
			}
		}
	}

	.candidato {
		margin-bottom: 15px;

		&.candidato-left {
			text-align: left;

			.candidato-img {
				margin-right: 11px;
			}

			.ganador-badge {
				left: 0;
			}
		}

		&.candidato-right {
			text-align: right;

			.candidato-img {
				margin-left: 11px;
				order: 1;
			}

			.progress ::v-deep .progress-bar {
				margin-left: auto;
			}

			.ganador-badge {
				right: 0;
			}
		}

		&.candidato-ganador {
			.ganador-badge {
				display: block;
			}

			.candidato-name {
				white-space: nowrap;
			}

			.fa-check {
				display: inline-flex;
			}

			.candidato-img {
				filter: none;
				opacity: 1;
			}
		}

		.candidato-img {
			filter: grayscale(1);
			flex: 0 0 75px;
			height: 100px;
			opacity: 0.4;
			width: 75px;
		}

		.candidato-top {
			align-items: flex-end;
			display: flex;
			justify-content: space-between;

			.candidato-name,
			.candidato-partido {
				display: none;
			}

			.candidato-text {
				position: relative;
				margin-bottom: 17px;
			}
		}

		.candidato-percentage {
			color: #368cf6;
			font-size: 22px;
			font-weight: 900;
			line-height: 27px;
			margin-bottom: 9px;
		}

		.candidato-votos {
			color: #172a4c;
			font-size: 12px;
			line-height: 15px;
		}

		.progress {
			background-color: rgba(#ccd8e2, 0.6);
			height: 8px;
			margin-top: -8px;
			margin-bottom: 8px;
			position: relative;
			overflow: visible;
			z-index: 1;

			::v-deep .progress-bar {
				background-color: #368cf6;
			}
		}

		.candidato-name {
			color: #172a4c;
			font-size: 14px;
			font-weight: bold;
			line-height: 17px;
			margin-bottom: 6px;
		}

		.candidato-partido {
			color: #172a4c;
			font-size: 12px;
			line-height: 15px;
		}
	}

	.ganador-badge {
		border-radius: 9px;
		background-color: #18dc97;
		display: none;
		color: #ffffff;
		font-size: 9px;
		font-weight: bold;
		line-height: 11px;
		padding: 3px 10px;
		position: absolute;
		top: -30px;
	}

	.fa-check {
		align-items: center;
		background-color: #18dc97;
		color: #fff;
		display: none;
		font-size: 9px;
		justify-content: center;
		border-radius: 50%;
		padding: 3px;
	}
}

.votacion-stats {
	margin: 0 auto;

	.votacion-stat {
		text-align: center;
	}

	.votacion-stat-name,
	.votacion-stat-value {
		font-size: 13px;
		line-height: 15px;
		text-align: center;
	}

	.votacion-stat-name {
		color: #5c6981;
		margin-bottom: 4px;
	}

	.votacion-stat-value {
		color: #172a4c;
		font-weight: bold;
		margin-bottom: 0;
	}
}

@media (min-width: 768px) {
	.content {
		margin-top: -39px;

		@at-root .iframe & {
			margin-bottom: 0;
			margin-top: 0;

			.votaciones-stats {
				padding-top: 27px;
			}

			.votaciones {
				overflow: auto;
				padding: 20px 0;
			}
		}
	}

	.votaciones {
		padding-top: 35px;
	}

	.votaciones,
	.votaciones-stats {
		max-width: 902px;
	}

	.votaciones-stats {
		.votaciones-stats-percentage-container,
		.votaciones-stats-national-text,
		.progress {
			max-width: 320px;
		}

		.votaciones-stats-percentage-container {
			margin-bottom: 5px;
		}

		.votaciones-stats-national-text {
			margin-bottom: 9px;
		}

		.votaciones-stats-info {
			display: flex;
			flex-direction: column;
			justify-content: center;
		}

		.votaciones-stats-last-update,
		.votaciones-stats-info-text {
			text-align: right;
		}
	}

	.votacion-stats {
		max-width: 390px;
	}

	.votacion {
		margin-bottom: 35px;

		.votacion-title {
			margin-bottom: -34px;
			font-size: 20px;
			line-height: 24px;
		}

		.candidato {
			&.candidato-left {
				.candidato-top {
					justify-content: flex-start;
				}

				.candidato-img {
					margin-right: 20px;
				}

				.candidato-percentage {
					margin-right: 30px;
				}

				.ganador-badge {
					left: auto;
					right: 0;
				}
			}

			&.candidato-right {
				.candidato-top {
					justify-content: flex-end;
				}

				.candidato-img {
					margin-left: 20px;
				}

				.candidato-percentage {
					margin-left: 30px;
					order: 1;
				}

				.ganador-badge {
					left: 0;
					right: auto;
				}
			}

			.candidato-img {
				height: 117px;
				flex: 0 0 95px;
				width: 95px;
			}

			.candidato-top {
				margin-top: 14px;
				position: relative;

				.candidato-text {
					margin-bottom: 24px;
					position: static;
				}

				.candidato-name,
				.candidato-partido {
					display: block;
				}
			}

			.candidato-bottom {
				display: none;
			}

			.candidato-name {
				font-size: 17px;
				line-height: 21px;
				margin-bottom: 5px;
			}

			.candidato-partido {
				font-size: 14px;
				line-height: 17px;
				margin-bottom: 13px;
			}

			.candidato-stats {
				align-items: flex-end;
				display: flex;
			}

			.candidato-percentage {
				margin-bottom: 0;
			}

			.candidato-votos {
				font-size: 14px;
				line-height: 17px;
			}

			.fa-check {
				font-size: 9px;
				padding: 3px;
			}

			.ganador-badge {
				bottom: 26px;
				top: auto;
			}

			.progress {
				height: 14px;
				margin-top: -14px;
				margin-bottom: 0;
			}
		}
	}
}
</style>
